import { render } from "./BaseOption.vue?vue&type=template&id=494b32d6"
import script from "./BaseOption.vue?vue&type=script&lang=js"
export * from "./BaseOption.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__